import { GIFT_REGISTRY_WIDGET_NAMES } from "@/constants/widget-names";
import { GiftCartDrawerWidgetDefinition } from "@apps/gift_registry/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class GiftCartDrawerWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start(): void {
        this.logger?.debug(`${GiftCartDrawerWidgetInjector.name}.start`, {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug(
                `${GiftCartDrawerWidgetInjector.name} found placeholder`,
                {
                    placeholder,
                }
            );

            const widgetName =
                GIFT_REGISTRY_WIDGET_NAMES.GIFT_CART_DRAWER_WIDGET;

            void (async () => {
                const GiftCartDrawerWidget =
                    await this.dynamicImportManager.importDefault(
                        GiftCartDrawerWidgetDefinition
                    );
                const widget = new GiftCartDrawerWidget(
                    {
                        target: placeholder,
                    },
                    this.logger
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default GiftCartDrawerWidgetInjector;
